import { useState } from 'react';

export interface UseDataTableFiltersProps {
  [key: string]: string;
}
export interface UseDataTableFiltersResponse {
  filters: UseDataTableFiltersProps;
  onFilterChange: (field: string, value: string) => void;
}

export const useDataTableFilters = (
  resetPagination?: () => void
): UseDataTableFiltersResponse => {
  const [filters, setFilters] = useState<UseDataTableFiltersProps>({});

  const onFilterChange = (field: string, value: string) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
    resetPagination?.();
  };

  return {
    filters,
    onFilterChange,
  };
};
